import { ClientEvents } from 'common/events/ClientEvents';
import React, { useEffect } from 'react';
import { Button } from 'src/shared/design-system/Buttons';
import { useIntersectionObserver } from 'src/shared/hooks/useIntersectionObserver';
import { useRefState } from 'src/shared/hooks/useRefState';
import { useTracker } from 'src/shared/hooks/useTracker';
import styled from 'styled-components';
import { Colors } from 'web-common/src/shared/styles';
import { useGotoReviews } from './useGotoReviews';

const InnerButton = styled(Button)`
  padding: 7px 13px;
  font-size: 16px;
  color: ${Colors.BLACK};
  background-color: ${Colors.GRAY_LITE_20};
  height: unset;
`;

export const OpenReviewsButton: React.FC = () => {
  const tracker = useTracker();
  const gotoReviews = useGotoReviews();

  const onClick = () => {
    tracker.track(ClientEvents.CLICK_REVIEWS_BUTTON, {
      position: 'section',
    });
    gotoReviews();
  };

  const [ref, setRef] = useRefState<HTMLButtonElement>();
  const { isIntersecting } = useIntersectionObserver({
    element: ref,
    initialState: false,
  });

  useEffect(() => {
    // this button is at the top of the section
    if (isIntersecting) {
      tracker.track(ClientEvents.VIEW_MENU_REVIEWS_SECTION, {});
    }
  }, [isIntersecting, tracker]);

  return (
    <InnerButton ref={setRef} onClick={onClick}>
      See all reviews
    </InnerButton>
  );
};
